import { Controller } from "@hotwired/stimulus";

// Prevents selecting a future date in the month/day/year "date of birth" selects
// rendered by DateOfBirthInput (Rails' date_select always suffixes the
// year/month/day field ids with _1i/_2i/_3i, regardless of display order).
export default class extends Controller {
  connect() {
    this.yearSelect = this.element.querySelector('select[id$="_1i"]');
    this.monthSelect = this.element.querySelector('select[id$="_2i"]');
    this.daySelect = this.element.querySelector('select[id$="_3i"]');

    if (!this.yearSelect || !this.monthSelect || !this.daySelect) return;

    this.onChange = () => this.enforceNotFuture();
    [this.yearSelect, this.monthSelect, this.daySelect].forEach((select) =>
      select.addEventListener("change", this.onChange)
    );

    this.enforceNotFuture();
  }

  disconnect() {
    if (!this.onChange) return;
    [this.yearSelect, this.monthSelect, this.daySelect].forEach((select) =>
      select?.removeEventListener("change", this.onChange)
    );
  }

  enforceNotFuture() {
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;
    const todayDay = today.getDate();

    const selectedYear = parseInt(this.yearSelect.value, 10);
    const isCurrentYear = selectedYear === todayYear;

    this.setOptionsDisabled(this.monthSelect, (value) =>
      isCurrentYear && value > todayMonth
    );
    if (isCurrentYear && parseInt(this.monthSelect.value, 10) > todayMonth) {
      this.monthSelect.value = String(todayMonth);
    }

    const selectedMonth = parseInt(this.monthSelect.value, 10);
    const isCurrentMonth = isCurrentYear && selectedMonth === todayMonth;

    this.setOptionsDisabled(this.daySelect, (value) =>
      isCurrentMonth && value > todayDay
    );
    if (isCurrentMonth && parseInt(this.daySelect.value, 10) > todayDay) {
      this.daySelect.value = String(todayDay);
    }
  }

  setOptionsDisabled(select, shouldDisable) {
    Array.from(select.options).forEach((option) => {
      if (!option.value) return;
      option.disabled = shouldDisable(parseInt(option.value, 10));
    });
  }
}
